<script setup>
import Message from "./Message.vue";

const props = defineProps(['contactUrl'])
</script>

<template>
    <Message type="info" :contactUrl="contactUrl">
        <p><strong>Sorry, this item is sold out right now.</strong> Check back soon, or contact us and we'll help you find what you're looking for.</p>
    </Message>
</template>
